// Аккаунт «этого окна». Мультиокно (по окну на аккаунт, как несколько окон
// Telegram Desktop): адрес /?account=<id> жёстко держит аккаунт окна и
// переживает F5, а localStorage-ключ tg-client:last-account-id остаётся лишь
// значением по умолчанию для окна, открытого без параметра. Без этого
// последний выбранный аккаунт в любом окне перетирал общий ключ и после
// перезагрузки все окна съезжались на один аккаунт.

const ACCOUNT_PARAM = "account";
export const LAST_ACCOUNT_STORAGE_KEY = "tg-client:last-account-id";

export const readWindowAccountId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const value = new URLSearchParams(window.location.search).get(ACCOUNT_PARAM);
    return value && value.trim().length > 0 ? value.trim() : null;
  } catch {
    return null;
  }
};

export const readLastAccountId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return window.localStorage.getItem(LAST_ACCOUNT_STORAGE_KEY);
  } catch {
    return null;
  }
};

// Аккаунт, с которым окно стартует: параметр адреса важнее общего ключа.
export const readBootAccountId = (): string | null =>
  readWindowAccountId() ?? readLastAccountId();

export const buildAccountUrl = (accountId: string): string => {
  const url = new URL(window.location.href);
  url.searchParams.set(ACCOUNT_PARAM, accountId);
  url.hash = "";
  return url.toString();
};

// Прописать аккаунт в адрес текущего окна (replaceState — без записи в
// историю, чтобы «назад» не листал аккаунты).
export const writeWindowAccountId = (accountId: string | null): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    const url = new URL(window.location.href);
    if (accountId) {
      url.searchParams.set(ACCOUNT_PARAM, accountId);
    } else {
      url.searchParams.delete(ACCOUNT_PARAM);
    }
    const next = url.pathname + url.search + url.hash;
    const current = window.location.pathname + window.location.search + window.location.hash;
    if (next !== current) {
      window.history.replaceState(window.history.state, "", next);
    }
  } catch {
    // ignore
  }
};

export const openAccountInNewWindow = (accountId: string): void => {
  if (typeof window === "undefined") {
    return;
  }
  window.open(buildAccountUrl(accountId), "_blank", "noopener");
};
